/** Styles for the facilitation notes chat: the admin editors' dark palette. */
import styled from '@emotion/styled';

export const Wrap = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid rgba(14, 94, 99, 0.6);
  background: rgba(14, 94, 99, 0.08);
  color: rgba(255, 255, 255, 0.9);
`;

export const Hint = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.55);
`;

export const Thread = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 360px;
  overflow-y: auto;
`;

export const Bubble = styled.div`
  align-self: ${(p) => (p.$me ? 'flex-end' : 'flex-start')};
  max-width: 92%;
  padding: 9px 12px;
  border-radius: 12px;
  background: ${(p) => (p.$me ? 'rgba(14, 94, 99, 0.45)' : 'rgba(255, 255, 255, 0.06)')};
  font-size: 14px;
  font-style: ${(p) => (p.$general ? 'italic' : 'normal')};
  line-height: 1.5;
  white-space: pre-wrap;
`;

export const Muted = styled.p`
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
`;

export const Composer = styled.form`
  display: flex;
  gap: 8px;
`;

export const Input = styled.input`
  flex: 1;
  min-width: 0;
  min-height: 40px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  font: inherit;
  font-size: 14px;
  &:disabled { opacity: 0.5; }
`;

export const Send = styled.button`
  min-height: 40px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid #0e5e63;
  background: #0e5e63;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  &:disabled { opacity: 0.45; cursor: default; }
`;

export const ErrorBox = styled.div`
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid rgba(248, 113, 113, 0.5);
  background: rgba(248, 113, 113, 0.12);
  color: #fecaca;
  font-size: 13px;
`;

export const Proposals = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ProposalsTitle = styled.h4`
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.55);
`;

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid ${(p) => (p.$accepted ? 'rgba(134, 239, 172, 0.45)' : 'rgba(255, 255, 255, 0.1)')};
  background: rgba(0, 0, 0, 0.25);
  .head { display: flex; align-items: center; gap: 10px; font-size: 12px; color: rgba(255, 255, 255, 0.6); }
  .head strong { color: rgba(255, 255, 255, 0.9); font-size: 13px; }
  .text { margin: 0; font-size: 14px; line-height: 1.5; white-space: pre-wrap; }
  .rationale { margin: 0; font-size: 12px; line-height: 1.45; color: rgba(255, 255, 255, 0.55); font-style: italic; }
  .warning { margin: 0; font-size: 12px; color: #fcd34d; }
  .original {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 6px 0 2px 10px;
    border-left: 2px solid rgba(255, 255, 255, 0.18);
    color: rgba(255, 255, 255, 0.6);
  }
  .original .label { font-size: 11px; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase; color: rgba(255, 255, 255, 0.45); }
  .original .text { font-size: 13px; }
  .original .empty { font-style: italic; color: rgba(255, 255, 255, 0.4); }
  .original ol { max-height: 200px; color: rgba(255, 255, 255, 0.6); }
  ol { margin: 0; padding-left: 20px; max-height: 320px; overflow-y: auto; font-size: 13px; line-height: 1.5; }
  li { margin-bottom: 4px; }
`;

export const Accept = styled.button`
  margin-left: auto;
  min-height: 30px;
  padding: 0 12px;
  border-radius: 7px;
  border: 1px solid ${(p) => (p.$accepted ? 'rgba(134, 239, 172, 0.5)' : 'rgba(255, 255, 255, 0.25)')};
  background: ${(p) => (p.$accepted ? 'rgba(134, 239, 172, 0.12)' : 'transparent')};
  color: ${(p) => (p.$accepted ? '#86efac' : '#fff')};
  font-size: 12px;
  cursor: pointer;
  &:disabled { cursor: default; opacity: ${(p) => (p.$accepted ? 1 : 0.45)}; }
`;
